import isWebKitBrowser from './is-webkit-browser'
import { scrollAnimate } from './scroll-animate'

const FAKE_INPUT_ID = 'fake-input'

const isDeviceOrientationPortrait = () => {
  if (window.orientation === 0 || window.orientation === 180) {
    return true
  }
  return false
}

export function scrollToTop() {
  if (isWebKitBrowser() && isDeviceOrientationPortrait()) {
    scrollAnimate.scrollTo(10)
  }
}

export function restoreScrollPosition(scrollToYCoordinates: number) {
  if (
    isWebKitBrowser() &&
    isDeviceOrientationPortrait() &&
    scrollToYCoordinates
  ) {
    scrollAnimate.scrollTo(scrollToYCoordinates)
  }
}

export function createHiddenInputElement() {
  const fakeInput = document.createElement('input')
  fakeInput.setAttribute('id', FAKE_INPUT_ID)
  fakeInput.setAttribute('data-testid', FAKE_INPUT_ID)
  fakeInput.setAttribute('type', 'text')
  fakeInput.setAttribute('aria-hidden', 'true')
  fakeInput.style.position = 'absolute'
  fakeInput.style.height = '0'
  fakeInput.style.opacity = '0'
  // iPhone auto zooms if input font size < 16
  fakeInput.style.fontSize = '16px'

  return fakeInput
}

export function removeHiddenInputElement() {
  const fakeInput = document.getElementById(FAKE_INPUT_ID)
  fakeInput?.remove()
}
